import { updateSettings } from "global/firestoreData/settings/updateSettings";
import { useContext, useMemo } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { AppContext } from "../AppProvider";

export const useSettings = () => {

  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainDb } = app_state ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  const settings_fns = useMemo(() => {
    // ALWAYS return fallback object
    return updateSettings(database_fns, mainDb);
  }, []);

  return settings_fns;
};

